import Vue from 'vue';
import Router from 'vue-router';
import multiguard from 'vue-router-multiguard';

import TITLES from '@/constants/titles';

import CookiePolicy from '@/routes/CookiePolicy';
import Oauth from '@/routes/Oauth';
import PasswordRestoration from '@/routes/PasswordRestoration';
import Registration from '@/routes/Registration';
import Signs from '@/routes/Signs';

import LocalCookieStorage from '@/service/localCookieStorage';

import isPublicAccessRestrictedMiddleware from '@/middlewares/is-public-access-restricted';
import { ALLOWED_LOCALES, DEFAULT_LANGUAGE, ONE_YEAR } from '@/constants/constants';
import i18n from './i18n';
import store from './store';


Vue.use(Router);


const setTitle = (params) => {
  let titleType;

  if (params.query.isCardActivation === 'true') {
    titleType = 'cardActivation';
  } else {
    titleType = params.meta.titleType ? params.meta.titleType : params.params.titleType;
  }

  if (params.query.redirect_uri || params.query.callback) {
    const url = new URL(params.query.redirect_uri || params.query.callback);
    let { origin } = url;

    if (origin === '' || origin === 'null' || origin === null) {
      origin = url.href;
    }

    store.commit('setRedirectUri', origin);

    if (params.query.callback) {
      store.commit('setIsCallback', true);
    }
  }

  let locale = DEFAULT_LANGUAGE;

  const localeFromStorage = LocalCookieStorage.get('current-language');

  if (localeFromStorage && ALLOWED_LOCALES.includes(localeFromStorage)) {
    locale = localeFromStorage.toLowerCase();
  }

  if (params.query.lang) {
    if (ALLOWED_LOCALES.includes(params.query.lang)) {
      locale = params.query.lang.toLowerCase();
    }
  }

  if (params.query.isHideCookiNotice) {
    LocalCookieStorage.set('cookie-allow', 'necessary', ONE_YEAR);
    store.commit('changeCookieAllowState', 'necessary');
  }

  LocalCookieStorage.set('current-language', locale);

  i18n.locale = locale;
  const title = TITLES[locale][titleType];

  document.title = title;
  LocalCookieStorage.set('current-title-type', titleType);
};

const router = new Router({
  base: __webpack_public_path__, // eslint-disable-line

  mode: 'history',

  routes: [
    ...CookiePolicy,
    ...Oauth,
    ...PasswordRestoration,
    ...Registration,
    ...Signs,

    {
      path: '*',
      redirect: '/sign_in',
    },
  ],
});

router.beforeEach(multiguard([
  isPublicAccessRestrictedMiddleware,
]));

router.afterEach((params) => {
  setTitle(params);
});

export default router;
